(function () {
  'use strict';
  var analytics = window.VanemarAnalytics;
  if (!analytics || analytics.forms) return;
  var track = analytics.track;
  var formStates = new WeakMap();
  var states = [];

  // Observe a meaningful section for one second, then stop after the first
  // consented view. Consent granted while it is visible restarts the timer.
  function observeView(element, send) {
    if (!element || !window.IntersectionObserver) return;
    var visible = false;
    var done = false;
    var timer;
    function check() {
      window.clearTimeout(timer);
      if (done || !visible || !analytics.isAllowed()) return;
      timer = window.setTimeout(function () {
        if (visible && analytics.isAllowed() && send()) {
          done = true;
          observer.disconnect();
          document.removeEventListener('vanemar:analytics-ready', check);
        }
      }, 1000);
    }
    var observer = new window.IntersectionObserver(function (entries) {
      visible = entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; });
      check();
    }, { threshold: [0, 0.5] });
    observer.observe(element);
    document.addEventListener('vanemar:analytics-ready', check);
    document.addEventListener('visitorConsentCollected', check);
  }

  function storage(state, operation, value) {
    try {
      if (operation === 'get') return window.sessionStorage.getItem(state.key);
      if (operation === 'set') window.sessionStorage.setItem(state.key, String(value));
      if (operation === 'remove') window.sessionStorage.removeItem(state.key);
    } catch (error) { /* Blocked browser storage must not affect forms. */ }
    return null;
  }

  function metadata(container) {
    return { form_type: container.dataset.analyticsForm, form_provider: container.dataset.analyticsProvider };
  }

  function stateFor(container) {
    if (!container) return null;
    var meta = metadata(container);
    if (['contact', 'newsletter'].indexOf(meta.form_type) < 0 || ['hubspot', 'shopify'].indexOf(meta.form_provider) < 0) return null;
    var state = formStates.get(container);
    if (state) return state;
    state = { container: container, meta: meta, viewed: false, started: false,
      submitting: false, error: false, form: null,
      key: 'vm_analytics_form:' + meta.form_type + ':' + window.location.pathname };
    formStates.set(container, state);
    states.push(state);
    observeView(container.querySelector('form, iframe') || container, function () { return view(state); });
    return state;
  }

  function view(state) {
    if (!state.viewed) state.viewed = track('site_form_view', state.meta);
    return state.viewed;
  }

  function start(state) {
    view(state);
    if (!state.started) state.started = track('site_form_start', state.meta);
  }

  function submit(container) {
    var state = stateFor(container);
    if (!state || state.submitting || !analytics.isAllowed()) return;
    start(state);
    state.submitting = track('site_form_submit', state.meta);
    state.error = false;
    // Only Shopify POST forms need a receipt across the ensuing page load.
    // It contains a timestamp, never a field value, contact ID or search term.
    if (state.submitting && state.meta.form_provider === 'shopify') storage(state, 'set', Date.now());
  }

  function complete(container) {
    var state = stateFor(container);
    if (!state || !state.submitting) return;
    state.submitting = false;
    storage(state, 'remove');
    track(state.meta.form_type === 'newsletter' ? 'newsletter_subscribe' : 'generate_lead', state.meta);
    // Checks marketing consent on its own; the GA4 event above only needed analytics.
    if (state.meta.form_type === 'contact' && analytics.conversion) analytics.conversion('lead');
  }

  function error(state, type) {
    if (!state.error) state.error = track('site_form_error', Object.assign({ error_type: type }, state.meta));
    state.submitting = false;
    storage(state, 'remove');
  }

  function ready(container, form) {
    var state = stateFor(container);
    // A HubSpot callback may contain a jQuery wrapper, or an iframe element
    // from another window. Use capabilities rather than instanceof Element.
    form = form && (form[0] || form);
    if (!state || !form || typeof form.addEventListener !== 'function' || state.form === form) return;
    state.form = form;
    form.addEventListener('focusin', function (event) {
      if (event.isTrusted && event.target.matches('input:not([type="hidden"]):not([type="submit"]), textarea, select')) start(state);
    });
    form.addEventListener('input', function (event) { if (event.isTrusted) start(state); });
    form.addEventListener('invalid', function (event) {
      if (event.isTrusted) { start(state); error(state, 'validation'); }
    }, true);
    if (state.meta.form_provider !== 'shopify') {
      if (window.MutationObserver) {
        var validationObserver = new window.MutationObserver(function () {
          if (!state.started || state.submitting) return;
          var message = form.querySelector('.hs-error-msgs li, .hs_error_rollup li');
          if (message && message.getClientRects().length) error(state, 'validation');
        });
        validationObserver.observe(form, { childList: true, subtree: true });
      }
      return;
    }
    form.addEventListener('submit', function (event) {
      if (!event.isTrusted || event.defaultPrevented || !form.checkValidity()) return;
      submit(container);
    });
    var receipt = Number(storage(state, 'get'));
    var recent = receipt > 0 && Date.now() >= receipt && Date.now() - receipt < 30 * 60 * 1000;
    var success = container.querySelector('.vm-contact__status--success, .vm-footer__news-msg--ok');
    var failed = container.querySelector('.vm-contact__status--error, .vm-footer__news-msg--err');
    if (analytics.isAllowed() && recent && (success || failed)) {
      state.submitting = true;
      if (success) complete(container);
      else error(state, 'server_response');
    } else if (!recent || !analytics.isAllowed()) storage(state, 'remove');
  }

  analytics.forms = { ready: ready, submit: submit, complete: complete };
  document.querySelectorAll('[data-analytics-form]').forEach(function (container) {
    ready(container, container.matches('form') ? container : container.querySelector('form'));
    // HubSpot may render after this script. Its callbacks attach the actual
    // inner form; the observer tracks the visible section in the meantime.
    stateFor(container);
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (analytics.isAllowed()) return;
    states.forEach(function (state) { state.submitting = false; storage(state, 'remove'); });
  });

  var searchState = document.querySelector('[data-analytics-search-state]');
  var search = searchState && searchState.closest('.vms');
  var searchViewed = false;
  function searchView() {
    if (!search || searchViewed || searchState.dataset.analyticsSearchState === 'idle') return;
    var count = Number(searchState.dataset.analyticsResultCount) || 0;
    searchViewed = track('search_results_view', { result_count: count });
    if (searchViewed && searchState.dataset.analyticsSearchState === 'empty') track('search_no_results', { result_count: 0 });
  }
  searchView();
  document.addEventListener('vanemar:analytics-ready', searchView);
  observeView(document.querySelector('#connect-planlari h2'), function () { return track('pricing_view'); });

  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    var target = event.target;
    var link = target.closest('a[href]');
    if (link) {
      var card = link.closest('[data-cs-card]');
      var result = link.closest('[data-analytics-result-type]');
      var productLink = false;
      var url;
      try { url = new URL(link.href, window.location.href); } catch (error) { url = null; }
      var handle = url && url.origin === window.location.origin && url.pathname.match(/\/products\/([a-z0-9-]+)\/?$/);
      if (handle) {
        productLink = true;
        var list = card && card.closest('[data-cs-root]');
        var listId = link.closest('.vms') ? 'search' : (analytics.pageType === 'product' ? 'related' : (analytics.pageType === 'index' ? 'home' : 'collection'));
        track('product_select', { product_handle: handle[1], product_id: card ? Number(card.dataset.analyticsProductId) : undefined,
          item_list_id: listId, result_index: list ? Array.from(list.querySelectorAll('[data-cs-card]')).indexOf(card) + 1 : 1 });
      }
      if (search && search.contains(link) && ((card && productLink) || result)) {
        var results = Array.from(search.querySelectorAll('[data-cs-card], [data-analytics-result-type]'));
        track('search_result_click', { result_type: card ? 'product' : result.dataset.analyticsResultType,
          result_index: results.indexOf(card || result) + 1 });
      }
    }
    if (target.closest('[data-vmc-checkout]')) track('checkout_click');
    var media = target.closest('[data-pdp-thumb], [data-pdp-next], [data-pdp-prev], [data-pdp-zoom], .pdp-media__img, [data-pdp-external-play]');
    if (media) {
      var action = media.matches('[data-pdp-thumb]') ? 'thumbnail' : media.matches('[data-pdp-next]') ? 'next' :
        media.matches('[data-pdp-prev]') ? 'previous' : media.matches('[data-pdp-external-play]') ? 'external_play' : 'zoom';
      track('product_media_interaction', { media_action: action, media_index: (Number(media.dataset.index) || 0) + 1, media_context: 'product' });
    }
  });

  // Only native product videos are handled here. Enhanced measurement owns
  // YouTube events; decorative looping/autoplay hero videos are excluded.
  var videos = new WeakMap();
  function videoState(video) {
    if (!video.matches('[data-pdp-root] video') || video.autoplay || video.loop || !video.controls) return null;
    var state = videos.get(video);
    if (!state) { state = { started: false, complete: false, milestones: new Set() }; videos.set(video, state); }
    return state;
  }
  function videoParams(video, percent) {
    return { media_context: 'product', video_provider: 'shopify', video_percent: percent,
      video_duration: video.duration, video_current_time: video.currentTime };
  }
  ['play', 'timeupdate', 'ended'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var video = event.target;
      if (!(video instanceof Element) || video.tagName !== 'VIDEO' || !analytics.isAllowed()) return;
      var state = videoState(video);
      if (!state) return;
      if (!state.started && (name === 'play' || !video.paused)) state.started = track('video_start', videoParams(video, 0));
      if (!state.started) return;
      if (name === 'timeupdate' && !video.seeking && video.duration > 0 && !video.paused) {
        var percent = 100 * video.currentTime / video.duration;
        [25, 50, 75].forEach(function (milestone) {
          // Only count crossing a milestone during playback, not seeking past it.
          if (percent >= milestone && percent < milestone + 5 && !state.milestones.has(milestone) && track('video_progress', videoParams(video, milestone))) state.milestones.add(milestone);
        });
      }
      if (name === 'ended' && !state.complete) state.complete = track('video_complete', videoParams(video, 100));
    }, true);
  });
})();
